import React from "react";

const IconDiscover = (props?: { iconFill?: string, className?: string, defs?: React.ReactNode }) => {
    return (
        <svg
            className={ props?.className }
            xmlns="http://www.w3.org/2000/svg"
            fillRule="evenodd"
            strokeLinejoin="round"
            strokeMiterlimit="2"
            clipRule="evenodd"
            viewBox="0 0 24 24"
        >
            { props?.defs ? props.defs : null }
            <path
                fillRule="nonzero"
                style={{fill: props?.iconFill}}
                d="M20.596 11.185h-.174v-.925h.184c.371 0 .573.156.573.453 0 .307-.202.472-.583.472m-16.84-.889h-.16v2.021h.16c.385 0 .629-.074.816-.243a1.05 1.05 0 0 0 .33-.77 1.03 1.03 0 0 0-.33-.761c-.197-.178-.431-.247-.816-.247M24 6v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h20a2 2 0 0 1 2 2m-4.173 6.835h.596v-1.228h.077l.825 1.228h.733l-.962-1.288c.449-.091.696-.398.696-.867 0-.572-.394-.902-1.082-.902h-.884v3.057zm-2.086 0h1.691v-.517h-1.095v-.825h1.055v-.518h-1.055v-.678h1.095v-.519h-1.691zm-3.208-3.057 1.297 3.135h.321l1.32-3.135h-.646l-.826 2.053-.815-2.053zm-3.094 1.545a1.659 1.659 0 1 0 3.317 0 1.659 1.659 0 0 0-3.317 0m-2.528-.014c0 .898.705 1.595 1.613 1.595.257 0 .476-.05.747-.178v-.702c-.238.239-.449.335-.72.335-.6 0-1.027-.435-1.027-1.054 0-.587.44-1.05.999-1.05.284 0 .5.102.747.344v-.702a1.608 1.608 0 0 0-2.359 1.412m-3.395 0c0-.902-.674-1.53-1.641-1.53H3v3.056h.871c.463 0 .797-.109 1.091-.353.348-.289.554-.724.554-1.173m.87-1.531H5.79v3.056h.596zm1.724 2.154c0 .248-.197.431-.463.431a.71.71 0 0 1-.651-.408l-.385.371c.275.403.605.582 1.058.582.62 0 1.054-.412 1.054-1.004 0-.486-.201-.705-.879-.953-.358-.132-.463-.22-.463-.385 0-.193.187-.339.444-.339.179 0 .325.073.481.247l.312-.408a1.34 1.34 0 0 0-.898-.338c-.541 0-.953.376-.953.876 0 .421.192.637.752.838.233.082.352.137.412.174a.37.37 0 0 1 .179.316M23 13.149s-5.731 4.044-16.226 5.854H21.75c.69 0 1.25-.56 1.25-1.25z">
            </path>
        </svg>
    )
};

export default IconDiscover;
